// Routes du module « Nomenclature et devis ».
import type { RouteObject } from 'react-router';
import '../../styles/devis.css';
import { PageDevisDossier } from './PageDevisDossier.tsx';
import { PageEditeurDevis } from './PageEditeurDevis.tsx';
import { PageCatalogue } from './PageCatalogue.tsx';
import { PageDevisRecu, PageImportDevisRecu } from './devis-recus.tsx';
import { PageBrouillonPdf, PageImportPdf } from './import-pdf.tsx';
import { PagePropositionChiffrage } from './proposition.tsx';

export const routesDevis: RouteObject[] = [
  { path: 'etudes/catalogue', element: <PageCatalogue /> },
  { path: 'etudes/:id/devis', element: <PageDevisDossier /> },
  { path: 'etudes/:id/devis/:quoteId', element: <PageEditeurDevis /> },
  { path: 'etudes/:id/devis/:quoteId/proposition', element: <PagePropositionChiffrage /> },
  { path: 'etudes/:id/devis-recus/import', element: <PageImportDevisRecu /> },
  { path: 'etudes/:id/devis-recus/:rid', element: <PageDevisRecu /> },
  { path: 'etudes/:id/devis-pdf/import', element: <PageImportPdf /> },
  { path: 'etudes/:id/devis-pdf/:pid', element: <PageBrouillonPdf /> },
];
